<h2 mat-dialog-title>
    <mat-icon color="warn" style="vertical-align: middle; margin-right: 8px;">error</mat-icon>
    Erro na Importação
</h2>

<mat-dialog-content>
    <p *ngIf="data.nomeArquivo" class="arquivo-nome">
        <strong>Arquivo:</strong> {{ data.nomeArquivo }}
    </p>
    <div class="mensagem-erro">
        {{ data.observacoes || 'Ocorreu um erro durante o processamento do arquivo.' }}
    </div>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
    <button (click)="fechar()" color="primary" mat-raised-button>Fechar</button>
</mat-dialog-actions>
